import { GridWidgetTask } from './grid-widget-task';
import { PaginateTask } from './paginate-task';

export class ResetPaginationTask extends GridWidgetTask {
  /**
   * The name of the task. Something like 'Filter', 'Paginate', or 'Sort'
   */
  name = 'reset-pagination';

  /**
   * The results of the last run will be stored here.
   */
  result: Array<any>;

  /**
   * The page number of the paginate task before being reset
   */
  previousPageNumber: number;

  /**
   * The paginate task that this task will communicate with.
   */
  paginateTask: PaginateTask;

  /**
   * The flag tells this task to ignore the next execution. This is used when a grid widget is being
   * restored from a persisted state and we do not want the page to be reset. This flag is
   * automatically reset once the next execution occurs.
   */
  skipNextExecution: boolean;

  getPriority(): number {
    return GridWidgetTask.RESET_PAGINATION_TASK_PRIORITY;
  }

  constructor(paginateTask: PaginateTask) {
    super();
    this.paginateTask = paginateTask;
  }

  preRunSetup(): void {
    if (!this.skipNextExecution) {
      //This will happen whether in server side mode or not.
      this.previousPageNumber = this.paginateTask.getPageNumber();
      this.paginateTask.setPageNumber(1);
    }
    this.skipNextExecution = false;
  }

  /**
   * The main function to exectute.
   */
  run(dataRows: Array<any>): Array<any> {
    if (dataRows == null) {
      return [];
    }

    //This task does not manipulate the data, so just pass it along
    return dataRows;
  }

  getPersistenceObject(): Object | undefined {
    if (this.paginateTask.getPageNumber() !== 1) {
      return 'skip-on-restore';
    }
  }

  restoreFromPersistenceObject(value: Object): void {
    if (<string>value === 'skip-on-restore') {
      this.skipNextExecution = true;
    }
  }
}
